import React from "react"

import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useLoginContext } from "src/hooks/useLoginContext"
import { Adviser } from "src/openapi"
import { Box, Image, Modal, Typography } from "src/UILibrary"

type Prop = {
  item?: Adviser
  open: boolean
  handleOpen: any
}

export const ReservationCompleteModal = ({ item, open, handleOpen }: Prop) => {
  const { t } = useTranslation("translation", { keyPrefix: "adviser" })

  const { getJobTitles } = useLoginContext()

  const navigate = useNavigate()

  if (!item) {
    return <></>
  }

  const handleClose = () => {
    handleOpen(false)
    navigate("/adviser")
  }

  return (
    <Modal
      open={open}
      onClose={() => handleClose()}
      sx={{ height: "auto" }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        width="sm"
        display="flex"
        flexDirection="column"
        sx={{ borderRadius: "10px", bgcolor: "white", borderColor: "white", py: "60px" }}
      >
        <Typography.Large sx={{ mx: "auto" }} className="font-large">
          {t("send_reservation")}
        </Typography.Large>
        <Typography.SubTitleNormal
          sx={{ mx: "auto", mt: "20px", fontFamily: "Noto Sans JP !important" }}
        >
          {t("will_accept_in_week")}
        </Typography.SubTitleNormal>
        <Box sx={{ mt: "20px", p: "20px", bgcolor: "#FBFAF4" }}>
          <Typography.SubHeadNormal>{t("reserving")}</Typography.SubHeadNormal>
          <Box display="flex" sx={{ mt: "20px" }}>
            <Image
              src={item.photoUrl as string}
              sx={{ width: "auto", height: "200px", maxWidth: "150px", bgcolor: "divider" }}
              imageStyle={{ width: "100%", height: "100%" }}
              alt=""
            />
            <Box sx={{ display: "flex", flexDirection: "column", p: "20px" }}>
              <Typography.SubHeadNormal>{`${item.lastName} ${item.firstName}${
                item.isResident ? `(${t("resident_adviser")})` : ""
              }`}</Typography.SubHeadNormal>
              <Typography.SubHeadNormal sx={{ mt: "20px", fontFamily: "Noto Sans JP !important" }}>
                {getJobTitles(item)}
              </Typography.SubHeadNormal>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}
